export default "__VITE_ASSET__CcJmR1Ll__"